import Select from './select.component';

export default Select;
